import appendQuery from 'append-query'
import { openPopup } from 'shared/util/gif-social'
import footerTemplate from './footer'
import gifTemplate from './gif'
import shareTemplate from './share'
import logoTemplate from './logo'
import backgroundTemplate from './background'
import css from './embed.css'

let isHover = false
let isShareOpen = false
let isPaused = false
let isMobileFooterOpen = false
let clipTimeout = null

global.showHover = isOn => {
    const embed = document.getElementById('giphy-embed')
    isHover = isOn
    embed.dataset.hover = isHover
    clearTimeout(clipTimeout)
    clipTimeout = setTimeout(() => {
        embed.dataset.clipit = isHover
    }, isHover ? 150 : 70)
}

global.toggleShareMenu = isClose => {
    const embed = document.getElementById('giphy-embed')
    isShareOpen = isClose ? false : !isShareOpen
    embed.dataset.shareopen = isShareOpen

    if (isShareOpen) {
        global.trackEvent('Click', 'Share')
    }
}

global.togglePlayPause = button => {
    const gif = document.getElementById('gif')
    isPaused = !isPaused
    if ('pause' in gif) {
        isPaused ? gif.pause() : gif.play()
    } else {
        gif.dataset.paused = isPaused
    }
    button.dataset.paused = isPaused
    global.trackEvent('Click', 'Pause')
}

global.toggleMobileFooter = () => {
    const embed = document.getElementById('giphy-embed')
    isMobileFooterOpen = !isMobileFooterOpen
    embed.dataset.mobilefooteropen = isMobileFooterOpen
}

global.openSharePopup = (url, type) => {
    global.trackEvent('Social Sharing', type.charAt(0).toUpperCase() + type.slice(1))
    openPopup(url, type)
}

export default function({ gif, hideVideo, isTwitter, trackingQueryString }, isWebpSupported) {
    isHover = false
    isShareOpen = false
    isPaused = false
    isMobileFooterOpen = false
    return `<div id="giphy-embed"
            class="${global.isMobile ? css.container : css.containerHoverable}"
            data-shareopen="false"
            onmouseover="showHover(true)"
            onmouseout="showHover(false)">
            <div class="${css.wrapper}">
                ${backgroundTemplate(gif.is_sticker)}
                ${gifTemplate(gif, { isWebpSupported, hideVideo, trackingQueryString })}
                ${logoTemplate(appendQuery('https://giphy.com', trackingQueryString))}
                ${footerTemplate(gif, { hideVideo, isTwitter, trackingQueryString })}
            </div>
            <div class="${css.cutout}"></div>
            ${shareTemplate(gif, trackingQueryString)}
            <svg class="${css.cutoutSvg}">
                <defs>
                    <clipPath id="cutout">
                        <rect x="-41" y="0" width="100%" height="100%" />
                        <rect x="0" y="41" width="100%" height="100%" />
                    </clipPath>
                </defs>
            </svg>
        </div>`
}
